export enum EngineType {
  COMPRESSOR = 'compressor',
  CONDENSER = 'condenser',
  PUMP = 'pump',
  NONE = 'none',
  OTHER = 'other'
}
